import backendHttpRequest from "./backendHttpRequest";
import { config } from "../configs/repositoryConfig";
import { convertToQueryString } from "../utilities/httpUtils";
import { replaceAllStringByKeys } from "../utilities/stringUtils";

export const getSummerSchoolResearch = async (filteredObject) => {
  const queryString = convertToQueryString(filteredObject);
  const resourceObject = {
    ...config.backendApiSettings.resources.getSummerSchoolResearch,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}${
    queryString ? `?${queryString}` : ""
  }`;

  const apiUsers = await backendHttpRequest({ resourceObject });
  return apiUsers;
};

export const getSummerSchoolResearchById = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.getSummerSchoolResearchById,
  };
  resourceObject.endpoint = replaceAllStringByKeys(
    resourceObject.endpoint,
    [":id"],
    [id]
  );

  const apiUser = await backendHttpRequest({ resourceObject });

  return apiUser;
};

export const updateSummerSchoolResearchStatus = async (id, status) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.updateSummerSchoolResearchStatus,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = `${endpoint}?${id}/${status}`;

  const apiUser = await backendHttpRequest({ resourceObject });

  return apiUser;
};

export const removeSummerSchoolResearch = async (id) => {
  const resourceObject = {
    ...config.backendApiSettings.resources.deleteSummerSchoolResearch,
  };
  const endpoint = resourceObject.endpoint;
  resourceObject.endpoint = endpoint.replace(":id", id);

  await backendHttpRequest({ resourceObject });

  return id;
};
